import {
    Route,
    Switch
} from "react-router-dom";

import AdminManagement from "../admin/AdminManagement";
import { ContactPage } from "../contact/ContactPage";
import CreateProperty from "../property/CreateProperty";
import { CreateUserPage } from "../../components/auth/CreateUserPage";
import { CustomerLinkBatchSetUpPage } from "../linkRegistry/CustomerLinkBatchSetUpPage";
import { CustomerLinkSetUpPage } from "../linkRegistry/CustomerLinkSetUpPage";
import EditSolution from "../../components/solution/EditSolution";
import Home from "../home/Home";
import { OrganizationManagementPage } from "../organization/OrganizationManagementPage";
import PropertiesPage from "../property/PropertiesPage";
import { PropertyDashboardPage } from "../property/PropertyDashboardPage";
import PropertyDetails from "../property/PropertyDetails";
import { QuickQuoteAssessment } from "../quickQuote/QuickQuoteAssessment";
import { QuickQuoteIssue } from "../quickQuote/QuickQuoteIssue";
import { RecoverImageBackups } from "../recovery/RecoverImageBackups";
import { SettingsPage } from "../settings/SettingsPage";
import { SolutionDashboard } from "../../components/solution/dashboard/SolutionDashboard";
import SyncTest from "../test/SyncTest";
import SystemReadyRoute from "./SystemReadyRoute";
import { TeamDashboard } from "../teamManagement/TeamDashboard";
import { UserProfile } from "../user/UserProfile";
import ViewLogin from "../login/ViewLogin";
import { ViewSettings } from "../settings/ViewSettings";
import ViewSolution from "../../components/solution/view/ViewSolution";

export const ContractorRoutes = () => {

    return (
        <Switch>
            <Route component={Home} path="/" exact />

            <SystemReadyRoute component={PropertiesPage} path="/properties" exact />
            <SystemReadyRoute component={UserProfile} path="/profile" exact />

            <SystemReadyRoute component={CreateProperty} path="/properties/create" exact />
            <SystemReadyRoute component={PropertyDashboardPage} path="/properties/:propertyId/dashboard" exact />

            {/* Routes for design components. */}
            <SystemReadyRoute component={EditSolution} path="/properties/:propertyId/solutions/create" exact />
            <SystemReadyRoute component={EditSolution} path="/properties/:propertyId/solutions/:solutionId/edit" exact />
            <SystemReadyRoute component={ViewSolution} path="/properties/:propertyId/solutions/:solutionId/view" exact />
            <SystemReadyRoute component={SolutionDashboard} path="/properties/:propertyId/solutions/:solutionId/dashboard" exact />

            <SystemReadyRoute component={PropertyDetails} path="/properties/:propertyId" />

            <Route component={ViewLogin} path="/login" exact />
            <SystemReadyRoute component={OrganizationManagementPage} path="/team" exact />
            <SystemReadyRoute component={TeamDashboard} path="/account/team" exact />

            <Route component={CustomerLinkSetUpPage} path="/link-registry/:id" exact />
            <Route component={CustomerLinkBatchSetUpPage} path="/link-registry/" exact />

            <Route component={ContactPage} path="/contacts" exact />

            <Route component={SettingsPage} path="/settings" exact />

            <Route component={QuickQuoteIssue} path="/quickEstimate/issue/:issueId" exact />
            <Route component={QuickQuoteAssessment} path="/quickEstimate/assessment/:assessmentId" exact />

            {/* 'Hidden' Pages */}
            <SystemReadyRoute component={AdminManagement} path="/admin" exact />
            <SystemReadyRoute component={ViewSettings} path="/view-settings" exact />
            <Route component={RecoverImageBackups} path="/recovery" exact />
            <Route component={CreateUserPage} path="/user/create" exact />
            {/* Test Page routes */}
            <Route component={SyncTest} path="/test/sync" exact />
        </Switch>
    );
};